// Recent working postcodes as one-tap chips (DEV-51044). Shared by the
// postcode screen and the Change Location drawer.
//
// Chips rather than stacked rows: three postcodes fit on one line at 375px.

import { Clock } from 'lucide-react'

export interface RecentLocationsProps {
  /** Newest first, already filtered of the postcode in use. */
  postcodes: string[]
  /**
   * Fills the postcode field with it. Nothing is applied: as with typing,
   * nearby branches are offered and the engineer confirms.
   */
  onSelect: (postcode: string) => void
  disabled?: boolean
  /** "h3" inside the drawer, whose own title is the h2. */
  headingLevel?: 'h2' | 'h3'
}

export function RecentLocations({
  postcodes,
  onSelect,
  disabled = false,
  headingLevel: Heading = 'h2',
}: RecentLocationsProps) {
  // Nothing recent (or a first-time engineer): show no empty section.
  if (postcodes.length === 0) {
    return null
  }

  return (
    <section aria-labelledby="recent-locations-heading">
      <Heading
        id="recent-locations-heading"
        className="mb-2 text-sm font-semibold text-gray-900"
      >
        Recent
      </Heading>
      <ul className="flex flex-wrap gap-2">
        {postcodes.map((postcode) => (
          <li key={postcode}>
            <button
              type="button"
              onClick={() => onSelect(postcode)}
              disabled={disabled}
              className="flex min-h-11 items-center gap-2 rounded-full border border-gray-300 bg-white px-3.5 text-sm font-semibold text-gray-900 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary disabled:cursor-not-allowed disabled:opacity-50"
            >
              <Clock
                className="h-3.5 w-3.5 flex-shrink-0 text-gray-500"
                aria-hidden="true"
              />
              {postcode}
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}
